/* Section component angulae */
import { BrowserModule, Title} from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { LocalStorageModule } from 'angular-2-local-storage';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
/* End section component angulae */
import { NgxSpinnerModule } from 'ngx-spinner';

/* Section Directivas */
import localeEsCo from '@angular/common/locales/es-CO';
registerLocaleData(localeEsCo, 'es-CO');
/* End section Directivas*/

/*  Section componets project */

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { AdminModule } from './admin/admin.module';
import { LoginModule } from './login/login.module';
import { AppHttpInterceptor } from './directives/http.interceptor';
import { HandleError } from './directives/hanledError';
// import { PdfMakeService } from './directives/pdfmake.config';
import { DxDataGridModule, DxButtonModule, DxSwitchModule } from 'devextreme-angular';
import { AuthService } from './services/auth.service';
import { ViewsModule } from './admin/views/views.module';


 
/* End section components project*/

@NgModule({
	declarations: [ AppComponent ],
	imports: [
		BrowserModule,
		AppRoutingModule,
		FormsModule,
		HttpModule,
		HttpClientModule,
		LocalStorageModule,
		AdminModule,
		LoginModule,
		DxDataGridModule,
		DxButtonModule,
		DxSwitchModule,
		LocalStorageModule.withConfig({
			prefix: 'opticaLocal',
			storageType: 'localStorage'
		}),
		ToastrModule.forRoot(),
		Ng4LoadingSpinnerModule.forRoot(),
		NgxSpinnerModule,
		ViewsModule
	],
	providers: [
		HandleError,
		// PdfMakeService,
		AuthService,
		Title,
		{ provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
		{ provide: LOCALE_ID, useValue: 'es-Co' }
	],
	bootstrap: [ AppComponent ]
})
export class AppModule {}
